<template>
  <section class="capability-section" id="capability">
    <div class="capability-container">
      <div class="section-header">
        <div class="section-eyebrow">Inspection capability</div>
        <h2 class="section-title">检测装备与技术能力</h2>
        <p>
          通过量具、仪表、激光干涉仪、动平衡与热成像等检测装备，获取设备状态与精度数据，为维修判断、精度恢复和交付验收提供依据。
        </p>
      </div>

      <div class="capability-matrix">
        <article class="capability-feature">
          <div class="feature-copy">
            <div class="feature-tag">定位精度检测</div>
            <h3>雷尼绍 XL80 激光干涉仪</h3>
            <p>
              用于定位精度检测与补偿验证，为设备精度状态评估、搬迁复装验收和精度恢复提供数据依据。
            </p>
          </div>
          <div class="feature-media">
            <ZoomableImage
              :src="require('@/assets/images/gallery/laser-diagnosis.jpg')"
              alt="雷尼绍 XL80 激光干涉仪现场检测"
              fit="cover"
            />
          </div>
        </article>

        <div class="capability-list">
          <article class="tool-card" v-for="item in tools" :key="item.title">
            <div class="tool-media">
              <ZoomableImage :src="getImage(item)" :alt="item.title" :fit="item.fit" />
            </div>
            <div class="tool-copy">
              <div class="tool-category">{{ item.category }}</div>
              <h3>{{ item.title }}</h3>
              <p>{{ item.desc }}</p>
            </div>
          </article>
        </div>
      </div>

      <div class="capability-bottom">
        <div class="capability-note">
          <strong>检测结果的作用</strong>
          <p>用于判断维修方向、验证改造/搬迁后的设备状态，并为后续预防性维护提供数据基础。</p>
        </div>
        <div class="capability-tags">
          <span>几何精度</span>
          <span>定位精度</span>
          <span>主轴状态</span>
          <span>电气温升</span>
          <span>振动与动平衡</span>
          <span>常规功能检测</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ZoomableImage from './ZoomableImage.vue';

export default {
  name: 'CapabilitySection',
  components: {
    ZoomableImage
  },
  data() {
    return {
      tools: [
        {
          category: '基础量具',
          title: '方尺 / 角尺 / 条尺',
          desc: '用于垂直度、直线度、平行度等常规几何项目检测。',
          base: 'capability',
          img: 'image32.jpeg',
          fit: 'cover'
        },
        {
          category: '常规仪表',
          title: '千分表 / 百分表',
          desc: '覆盖多规格量程，用于几何误差、装配状态和现场快速检测。',
          base: 'gallery',
          img: 'dial-indicator.jpg',
          fit: 'cover'
        },
        {
          category: '主轴检测',
          title: '检验棒 / 主轴拉力检测仪',
          desc: '支持 BT、SK、HSK 等主轴锥孔拉力测试和主轴精度检测。',
          base: 'gallery',
          img: 'spindle-tension.jpg',
          fit: 'cover'
        },
        {
          category: '振动检测',
          title: 'SB-8802 现场动平衡仪',
          desc: '用于主轴、大型电机、同步带轮的现场动平衡与振动检测。',
          base: 'gallery',
          img: 'balancing-kit.jpg',
          fit: 'cover'
        },
        {
          category: '平面检测',
          title: 'RSK 精密水平仪',
          desc: '用于高精度直线度和平面度检测，辅助找平找正。',
          base: 'capability',
          img: 'image43.jpeg',
          fit: 'cover'
        },
        {
          category: '电气诊断',
          title: '电气检测设备',
          desc: '包含万用表、钳形表、电子摇表，用于电气系统常规排查。',
          base: 'gallery',
          img: 'electric-meter.jpg',
          fit: 'cover'
        },
        {
          category: '热成像',
          title: '热成像检测仪',
          desc: '检测电柜、电机等温度分布，为异常温升和接触问题判断提供依据。',
          base: 'gallery',
          img: 'thermal-imaging.jpg',
          fit: 'cover'
        }
      ]
    };
  },
  methods: {
    getImage(item) {
      return require('@/assets/images/' + item.base + '/' + item.img);
    }
  }
};
</script>

<style scoped>
.capability-section {
  background: linear-gradient(180deg, #ffffff 0%, #f6f9fd 100%);
  padding: 88px 0;
}

.capability-container {
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 24px;
}

.section-header {
  max-width: 860px;
  margin-bottom: 28px;
}

.section-eyebrow {
  color: #1976d2;
  font-size: 0.88rem;
  font-weight: 900;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  margin-bottom: 10px;
}

.section-title {
  margin: 0 0 12px;
  color: #132033;
  font-size: 2.2rem;
  font-weight: 900;
  letter-spacing: 1px;
}

.section-header p {
  margin: 0;
  color: #536173;
  line-height: 1.9;
}

.capability-matrix {
  display: grid;
  grid-template-columns: minmax(360px, 0.9fr) 1.1fr;
  gap: 18px;
}

.capability-feature,
.tool-card,
.capability-note {
  background: #ffffff;
  border: 1px solid #e8eef6;
  box-shadow: 0 16px 40px rgba(16, 35, 64, 0.06);
}

.capability-feature {
  border-radius: 26px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.feature-copy {
  padding: 24px;
}

.feature-tag,
.tool-category {
  display: inline-flex;
  color: #1976d2;
  background: rgba(25, 118, 210, 0.09);
  border-radius: 999px;
  padding: 5px 10px;
  font-size: 0.82rem;
  font-weight: 900;
  margin-bottom: 12px;
}

.feature-copy h3,
.tool-copy h3 {
  margin: 0 0 10px;
  color: #132033;
  font-weight: 900;
}

.feature-copy p,
.tool-copy p {
  margin: 0;
  color: #536173;
  line-height: 1.85;
}

.feature-media {
  flex: 1;
  min-height: 360px;
  background: #ffffff;
  border-top: 1px solid #e8eef6;
}

.capability-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.tool-card {
  border-radius: 20px;
  overflow: hidden;
}

.tool-media {
  height: 190px;
  background: #ffffff;
  border-bottom: 1px solid #e8eef6;
}

.tool-copy {
  padding: 16px;
}

.capability-bottom {
  margin-top: 18px;
  display: grid;
  grid-template-columns: 0.85fr 1.15fr;
  gap: 18px;
  align-items: stretch;
}

.capability-note {
  border-radius: 20px;
  padding: 18px;
}

.capability-note strong {
  display: block;
  color: #132033;
  margin-bottom: 8px;
}

.capability-note p {
  margin: 0;
  color: #536173;
  line-height: 1.8;
}

.capability-tags {
  background: #132033;
  border-radius: 20px;
  padding: 18px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-content: center;
}

.capability-tags span {
  color: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(255, 255, 255, 0.08);
  border-radius: 999px;
  padding: 8px 12px;
  font-weight: 800;
  font-size: 0.92rem;
}

@media (max-width: 1100px) {
  .capability-matrix,
  .capability-bottom {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .capability-section {
    padding: 60px 0;
  }

  .section-title {
    font-size: 1.75rem;
  }

  .capability-list {
    grid-template-columns: 1fr;
  }

  .feature-media {
    min-height: 260px;
  }
}
</style>
